import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import Divider from "@mui/material/Divider";
import { getAllDataPoints } from "../../indexDB/utils/datapoint";
import { getAllDrafts } from "../../indexDB/utils/draft";
import { Offline, Online } from "react-detect-offline";

const Navbar = ({ loggedIn, setConfirmDialog = () => { } }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const history = useNavigate();

  const handleLogout = async () => {
    const datapointLength = await getAllDataPoints()
    const draftLength = await getAllDrafts()
    setConfirmDialog({ open: true, 
      text: `Are you sure you want to log out? You will lose your ${datapointLength.length > 0 ? datapointLength.length + " " : ""}unsynced form${datapointLength.length > 1 ? 's' : ''}, ${draftLength.length > 0 ? 'drafts, ' : ''}and all saved data.`, 
      type: "logout", buttonText: "Confirm" 
    })
    setDrawerOpen(false)
    return
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const clickToGoHome = () => {
    history("/")
  }
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);


  return (
    <AppBar
      position="fixed"
      color="default"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="h6" noWrap component="div" sx={{ "&:hover": { cursor: "pointer" } }} onClick={clickToGoHome}>
              Collect Pro
            </Typography>
          </Box>
        </Box>

        <div style={{ flexGrow: 1 }} />
    
        <Box sx={{ 
          borderRadius: "20px",
          display: "flex",
          alignItems: "center",
          padding: "4px 16px", 
          marginRight: "2%", 
          border: "1px solid", 
          }}>
          {isOnline ? (
            <span style={{ color: "green" }}>● Online</span>
          ) : (
            <span style={{ color: "red" }}>● Offline</span>
          )}
        </Box>

        {loggedIn && (
          <>
            <Box sx={{ mr: 1 }}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            </Box>

            <Drawer
              sx={{
                width: { xs: "80%", md: "50%" }, // Set width to 80% on extra small screens and 50% on medium screens and above
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: {
                  width: "100%", // Set width of .MuiDrawer-paper to 100% initially
                  maxWidth: { xs: "80%", md: "50%" }, // Limit the maximum width of .MuiDrawer-paper to 80% on extra small screens and 50% on medium screens and above
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between", // Align content at the bottom
                },
              }}
              anchor="right"
              open={drawerOpen}
              onClose={handleDrawerToggle}
            >
              <List>
                <Toolbar />
                <ListItem
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "50px",
                  }}
                >
                  <ListItemText primary={localStorage.getItem("username")} />
                </ListItem>

                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        onClick={() =>
                          window.open(
                            "https://drive.google.com/file/d/1TSVgIlxc7O09MvBhuIti7VytVTw2SI-1/view",
                            "_blank"
                          )
                        }
                      >
                        Application Tutorial
                      </Typography>
                    }
                  />
                </ListItem>
                <Divider
                  sx={{
                    borderWidth: "1px",
                    borderColor: "#2f3636",
                  }}
                  variant="middle"
                  component="li"
                />
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        onClick={() =>
                          window.open(
                            "https://docs.google.com/presentation/d/1fXehGHKT3Fn7A9-GdqC6ImV7u0hYsBIx8J8c6r-1JFE/edit?usp=sharing",
                            "_blank"
                          )
                        }
                      >
                        User Guide
                      </Typography>
                    }
                  />
                </ListItem>
                <Divider
                  sx={{
                    borderWidth: "1px",
                    borderColor: "#2f3636",
                  }}
                  variant="middle"
                  component="li"
                />
                <ListItem>
                  <ListItemText primary="FAQs" />
                </ListItem>
                <Divider
                  sx={{
                    borderWidth: "1px",
                    borderColor: "#2f3636",
                  }}
                  variant="middle"
                  component="li"
                />
                <ListItem>
                  <ListItemText primary="Report an Issue" />
                </ListItem>
                <Divider
                  sx={{
                    borderWidth: "1px",
                    borderColor: "#2f3636",
                  }}
                  variant="middle"
                  component="li"
                />
              </List>
              <List>
                <ListItem>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      justifyItems: "around",
                      color: "text.secondary",
                      "& svg": {
                        m: 1,
                      },
                      "& hr": {
                        mx: 0.5,
                      },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: "12px", md: "14px" },
                      }}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open(
                          "https://docs.google.com/document/d/1NvP-vSEx826MlbBRafGaZoxoW5DIyrYPid8odr-9DyA",
                          "_blank"
                        )
                      }
                    >
                      Terms & Conditions
                    </Typography>
                    <Divider
                      sx={{
                        borderWidth: "0.5px",
                        borderColor: "#2f3636",
                      }}
                      orientation="vertical"
                      flexItem
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: "12px", md: "14px" },
                      }}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open(
                          "https://docs.google.com/document/d/1PFIMUJi4KqawetOVZhM-eRU_OCUsJzz9Mn0uF8XkxxI",
                          "_blank"
                        )
                      }
                    >
                      Privacy Policy
                    </Typography>
                  </Box>
                </ListItem>
                <ListItem>
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<ExitToAppIcon />}
                    onClick={handleLogout}
                    style={{ width: "100%" }}
                  >
                    Logout
                  </Button>
                </ListItem>
              </List>
            </Drawer>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
